import actionTypes from '../constants/action-types.js';

const adjacentPosition = (state = null, action) => {
  if (action.type !== actionTypes.SET_ADJACENT_POSITION) return state;
  return action.payload.position;
};

export default adjacentPosition;
